<div class="row my-2">
    <div class="col-lg-12 col-md-12 col-sm-12 m-auto text-center">
        <p class="title mb-0">Última etapa!</p>
    </div>
</div>

<div class="row my-2">
    <div class="col-lg-12 col-md-12 col-sm-12 m-auto text-center">
        <p class="subtitle">Preencha os dados da empresa</p>
    </div>
</div>

<div class="row my-3">
    <div class="col-lg-4 col-md-4 col-sm-12 m-auto">
        <form *ngIf="cedenteGestorCadastroFormGroup" [formGroup]="cedenteGestorCadastroFormGroup" #cedenteGestorCadastroForm="ngForm" (ngSubmit)="onSubmit(cedenteGestorCadastroFormGroup.value)">
            <div class="py-2">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 m-auto py-2">
                        <div formGroupName="cedenteCadastro">
                            <div class="input-container">
                                <input formControlName="cnpj" [textMask]="{mask: MASKS.cnpj.textMask}" id="cnpj" class="input" type="text" [(ngModel)]="inDocumento" (blur)="CompleteWithZero(formCedenteCadastro.get('cnpj').value)" autocomplete="off"/>
                                <label class="label" for="cnpj">CNPJ</label>
                            </div>
                            <div *ngIf="formCedenteCadastro.get('cnpj').invalid && (formCedenteCadastro.get('cnpj').dirty || formCedenteCadastro.get('cnpj').touched)" class="text-danger">
                                <div *ngIf="formCedenteCadastro.get('cnpj').errors.required">
                                    CNPJ obrigatório
                                </div>
                                <div *ngIf="formCedenteCadastro.get('cnpj').errors.cnpj">
                                    CNPJ inválido
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12 m-auto py-2">
                        <div formGroupName="cedenteCadastro">
                            <div class="input-container">
                                <input formControlName="nomeFantasia" id="nomeFantasia" class="input" type="text" readonly />
                                <label class="label" for="nomeFantasia">Nome fantasia</label>
                            </div>
                            <!--<div *ngIf="formCedenteCadastro.get('nomeFantasia').invalid && (formCedenteCadastro.get('nomeFantasia').dirty || formCedenteCadastro.get('nomeFantasia').touched)" class="text-danger">
                                <div *ngIf="formCedenteCadastro.get('nomeFantasia').errors.required">
                                    Nome fantasia obrigatório
                                </div>
                                <div *ngIf="formCedenteCadastro.get('nomeFantasia').errors.minlength">
                                    Nome fantasia deve conter mais de 3 caracteres
                                </div>
                                <div *ngIf="formCedenteCadastro.get('nomeFantasia').errors.maxlength">
                                    Nome fantasia deve conter no máximo 200 caracteres
                                </div>
                            </div>-->
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 m-auto py-2">
                        <div formGroupName="cedenteCadastro">
                            <div class="input-container">
                                <input formControlName="razaoSocial" id="razaoSocial" class="input" type="text" readonly/>
                                <label class="label" for="razaoSocial">Razão social</label>
                            </div>
                            <!--<div *ngIf="formCedenteCadastro.get('razaoSocial').invalid && (formCedenteCadastro.get('razaoSocial').dirty || formCedenteCadastro.get('razaoSocial').touched)" class="text-danger">
                                <div *ngIf="formCedenteCadastro.get('razaoSocial').errors.required">
                                    Razão social obrigatória
                                </div>
                                <div *ngIf="formCedenteCadastro.get('razaoSocial').errors.minlength">
                                    Razão social deve conter mais de 3 caracteres
                                </div>
                                <div *ngIf="formCedenteCadastro.get('razaoSocial').errors.maxlength">
                                    Razão social deve conter no máximo 150 caracteres
                                </div>
                            </div>-->
                        </div>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12 m-auto py-2">
                        <div formGroupName="cedenteCadastro">
                            <div class="input-container">
                                <input formControlName="telefoneNumero" [textMask]="{mask: telefoneCelularMask}" id="telefoneNumero" class="input" type="text" autocomplete="off"/>
                                <label class="label" for="telefoneNumero">Telefone da empresa</label>
                            </div>
                            <div *ngIf="formCedenteCadastro.get('telefoneNumero').invalid && (formCedenteCadastro.get('telefoneNumero').dirty || formCedenteCadastro.get('telefoneNumero').touched)" class="text-danger">
                                <div *ngIf="formCedenteCadastro.get('telefoneNumero').errors.required">
                                    Telefone é obrigatório
                                </div>
                                <div *ngIf="formCedenteCadastro.get('telefoneNumero').errors.celular">
                                    Telefone inválido
                                </div>
                                <div *ngIf="formCedenteCadastro.get('telefoneNumero').errors.isCellPhone">
                                    Telefone deve conter o dígito 9
                                </div>
                                <div *ngIf="formCedenteCadastro.get('telefoneNumero').errors.telefone">
                                    Telefone inválido
                                </div>
                            </div>
                        </div>
                    </div>



                    <!--checkbox termo de uso-->
                    <div class="col-lg-12 col-md-12 col-sm-12 m-auto py-2">
                        <input formControlName="termoAceito" disabled id="termoAceito" type="checkbox" class="checkbox" />
                        <label for="termoAceito" class="custom-label clickable" (click)="showTermo(termo)">Eu li e
                            aceito os&nbsp;<u class="custom-u">Termos de Uso</u>.</label>
                    </div>
                </div>

                <div class="row button-container">
                    <div class="col-12 d-flex justify-content-center">
                        <button [disabled]="!cedenteGestorCadastroForm.valid || !termoAceito || !cnpjValido" type="submit" class="button">
                            <span>Cadastrar</span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>

<ng-template #termo let-modal>
    <div class="row px-4 text-center">
        <div class="col-12 my-2">
            <p class="title">Termos de Uso</p>
        </div>
        <div class="col-12 my-2">
            <iframe class="custom-termo" [src]="termoUsoContaCorrente.url | safe"></iframe>
        </div>
        <div class="col-12 my-2">
            <button type="button" (click)="acceptTermo();modal.dismiss('Close click')" class="button">
                <span>Aceito</span>
            </button>
        </div>
        <div class="col-12 my-2">
            <button type="button" (click)="refuseTermo();modal.dismiss('Close click')" class="button refuse">Recusar</button>
        </div>
    </div>
</ng-template>
